import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Work", path: "/work" },
];

export default function Header() {
  const location = useLocation();
  const cursorRef = useRef(null);

  // Custom cursor
  useEffect(() => {
    const cursor = cursorRef.current;
    const moveCursor = (e) => {
      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
    };
    const expandCursor = () => cursor.classList.add("expand");
    const shrinkCursor = () => cursor.classList.remove("expand");

    document.addEventListener("mousemove", moveCursor);

    const hoverTargets = document.querySelectorAll("a, .work-card, .skill-pill");
    hoverTargets.forEach((el) => {
      el.addEventListener("mouseenter", expandCursor);
      el.addEventListener("mouseleave", shrinkCursor);
    });

    return () => {
      document.removeEventListener("mousemove", moveCursor);
      hoverTargets.forEach((el) => {
        el.removeEventListener("mouseenter", expandCursor);
        el.removeEventListener("mouseleave", shrinkCursor);
      });
    };
  }, [location]); // re-run on route change so new elements get cursor listeners

  return (
    <>
      {/* Custom cursor */}
      <div className="cursor" ref={cursorRef} id="cursor" />

      <nav className="nav">
        <Link to="/" className="nav-logo">
          YELANI.DESIGN
        </Link>

        <ul className="nav-links">
          {navLinks.map(({ label, path }) => (
            <li key={path}>
              <Link
                to={path}
                className={`nav-link ${location.pathname === path ? "active" : ""}`}
              >
                {label}
              </Link>
            </li>
          ))}
          <li>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="nav-link"
            >
              LinkedIn ↗
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
}